import React, { useState } from "react";

export default function ProceduriOperarionalePage() {

    const files = [
    "Decizia CA.pdf",
    "Decizia comisia CEAC.PDF",
    "Decizia Comisia Cod etica.PDF",
    "Decizia Comisia curriculum.PDF",
    "Decizia Comisia de arhivare.PDF",
    "Decizia Comisia de cercetare disciplinara.PDF",
    "Decizia Comisia de circuite informatii inter si intra.PDF",
    "Decizia Comisia de disciplina.PDF",
    "Decizia Comisia de receptie_doc_f.PDF",
    "Decizia Comisia eliminarea violentei_coruptie_discriminare_desegregare.PDF",
    "Decizia Comisia intocmire ROF ROI.PDF",
    "Decizia Comisia paritara.PDF",
    "Decizia Comisia programe si proiecte educative.PDF",
    "Decizia Comisia SCIM.PDF",
    "Decizia Comisia siguranta scolara.PDF",
    "Decizia Comisia violenta_coruptie_discriminare.PDF",
    "Decizia Comisisa circuitul informatiei.PDF",
    "Decizia Consilier educativ.PDF",
    "Decizia consiliul profesoral.PDF",
    "Decizia coordonatori structuri.PDF",
    "Decizia Grup de lucru evaluare risc de coruptie.PDF",
    "Decizia PNRAS_activitati de remediere_extracurriculare.PDF",
    "Decizia PNRAS_activitati_MATE.PDF",
    "Decizia PNRAS_echipa de implementare proiect.PDF",
    "Decizia PNRAS_echipa de scriere proiect.PDF",
    "Decizia responsabil_risc_secretariat.PDF",
    "Decizia responsabil sanse egale intre femei si barbati.PDF",
    "Decizia secretar CP.pdf",
    ];

const [visibleCount, setVisibleCount] = useState(5);
 
   const handleShowMore = () => setVisibleCount((prev) => prev + 5);
   const handleShowLess = () => setVisibleCount(5);
 
   return (
     <div className="bg-gray-50">
       <main className="max-w-7xl mx-auto px-4 py-8">
 
         <ul>
           {files.slice(0, visibleCount).map((file) => (
             <li key={file} className="mb-3 flex items-center flex-wrap">
               <span className="font-bold text-lg mr-3">
                 {file.replace(".PDF", "")}
               </span>
               <a
                 href={`/documente/hotarariCA/${encodeURIComponent(file)}`}
                 target="_blank"
                 rel="noopener noreferrer"
                 className="text-blue-600 underline"
               >
                 Deschide
               </a>
             </li>
           ))}
         </ul>
 
         <div className="mt-6 flex space-x-4">
           {visibleCount < files.length && (
             <button
               onClick={handleShowMore}
               className="px-4 py-2 rounded transition"
               style={{
                 backgroundColor: "rgba(170,190,107,0.8)",
                 color: "black",
               }}
               onMouseEnter={(e) =>
                 (e.target.style.backgroundColor = "rgba(170,190,107,1)")
               }
               onMouseLeave={(e) =>
                 (e.target.style.backgroundColor = "rgba(170,190,107,0.8)")
               }
             >
               Arată mai multe
             </button>
           )}
 
           {visibleCount > 5 && (
             <button
               onClick={handleShowLess}
               className="px-4 py-2 rounded transition"
               style={{
                 backgroundColor: "red",
                 color: "white",
               }}
               onMouseEnter={(e) => (e.target.style.backgroundColor = "darkred")}
               onMouseLeave={(e) => (e.target.style.backgroundColor = "red")}
             >
               Ascunde
             </button>
           )}
         </div>
       </main>
     </div>
   );
 }
 